export default __webpack_public_path__ + "static/media/clients.2d78cb62.svg";